// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#password-requirements {
    max-width: 250px;

    .valid {
        color: green;
    }

    .invalid svg {
        color: red;
    }

    > div {
        margin: 5px 10px 10px 10px;
        display: flex;
    }

    svg {
        margin-top: 3px;
    }

    .requirements-title {
        font-weight: bold;
    }
    
    .requirement-text {
        margin-left: 5px;
    }

    .requirement-text ul {
        list-style: disc;
        padding-left: 12px;
        padding-top: 3px;
    }
}

`, "",{"version":3,"sources":["webpack://./src/components/PasswordTippy/PasswordTippy.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;;IAEhB;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,0BAA0B;QAC1B,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,gBAAgB;IACpB;AACJ","sourcesContent":["#password-requirements {\n    max-width: 250px;\n\n    .valid {\n        color: green;\n    }\n\n    .invalid svg {\n        color: red;\n    }\n\n    > div {\n        margin: 5px 10px 10px 10px;\n        display: flex;\n    }\n\n    svg {\n        margin-top: 3px;\n    }\n\n    .requirements-title {\n        font-weight: bold;\n    }\n    \n    .requirement-text {\n        margin-left: 5px;\n    }\n\n    .requirement-text ul {\n        list-style: disc;\n        padding-left: 12px;\n        padding-top: 3px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
